export default "__VITE_ASSET___app/immutable/assets/modal-logo-light-green.B2oja7WE.svg__"